export default __webpack_public_path__ + "static/media/az.ffc79bfa.svg";